export class AccountKycList {   
    id: number = 0;
    applicationNumber: string = '';
    accountNumber: string = '';
    spn: string = '';
    area: string = '';
    region: string = '';
    address: string = '';
    feederBand: string = '';
    feederName: string = '';
    dtName: string = '';
    geographicalRegion: string = '';
    subGeographicalRegion: string = '';
    substationName: string = '';
    acLineName: string = '';
    acLineBand: string = '';
    buildingOwner: string = '';
    kycStatus: string = '';
    tag: string = '';
    isChecked: boolean;
    isPaid: boolean;
    sltStatus?: string;
    subserviceType: string = '';
    subServiceType: string = '';
    projectStatus: string = '';
    projectDesignation: string = '';
    assignedVendor: string = '';
    requestCount: number;
}

export class OnboardedCustomersList extends AccountKycList {
    serviceOrderId: string = '';
}

export enum KycDownloadReportType {
  ServiceRequestReport = 1,
  CustomerConsentReport = 2,
  OnboardedServiceRequestReport = 3,
  OnboardedCustomerConsentReport = 4,
  ServiceRequestTrackerReport = 5,
}

export class ServiceRequestTrackerItem extends AccountKycList {
  serviceOrderId: string = '';
  mapId: string = '';
  customerName: string = '';
  phoneNumber: string = '';
  emailAddress: string = '';
  upriserName: string = '';
  meterNumber: string = '';
  oldMeterNumber: string = '';
  installationDate: string = '';
  simNo: string = '';
  meterType: string = '';
  useOfPremise: string = '';
  typeOfConnection: string = '';
  recommendedTariff: string = '';
  recommendedMeterType: string = '';
  serviceRequestStatus: string = '';
  serviceRequestReviewedBy: string = '';
  serviceRequestReviewDate: string = '';
  siteVerificationStatus: string = '';
  siteVerificationCapturedBy: string = '';
  siteVerificationDate: string = '';
  siteVerificationReviewedBy: string = '';
  siteVerificationReviewDate: string = '';
  accountCreatedBy: string = '';
  applicationStage: string = '';
  applicationDate: string = '';
}